<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="text-center">
          <br />
          <div class="centered" style="color: #3c6837">
            <h1>
              <em class="not-found-icon nc-icon nc-puzzle-10"></em>
              {{ $t('vie.Pag.Das.Gen.attention') }}
            </h1>
          </div>
          <hr style="width: 95%" />
          <p style="color: #3c6837">
            {{ $t('vie.Pag.Das.Gen.noPermissions') }}
          </p>
          <br />
          <p class="text-center text-muted">
            {{ $t('vie.Pag.Das.Gen.boostYourOrganization') }}<br />
            <a href="https://smartcultivo.com/contacto/" target="_blank">{{
              $t('vie.Pag.Das.Gen.contactUs')
            }}</a>
          </p>
          <br />
          <br />
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import AuthLayout from 'src/views/Layouts/AuthLayout.vue';

export default {
  components: {
    AuthLayout,
  },

  mounted() {
    setTimeout(() => {
      for (let key of document.getElementsByClassName('icon-left-menu')) {
        key.parentElement.parentElement.className = 'nav-item';
        key.parentElement.className = 'nav-link';
        if (key.parentElement.dataset['toggle'] == 'collapse') {
          key.parentElement.click();
        }
      }
    }, 1);
  },

  created() {
    sessionStorage.setItem('urlModule', this.$route.path);
  },
};
</script>
